import { FileRepresentation } from '@/components/form-builder/form-builder.types';
import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressBarModule } from 'primeng/progressbar';
import { TooltipModule } from 'primeng/tooltip';
import { Observable, of, Subscription } from 'rxjs';

@Component({
  selector: 'sm-file-list',
  imports: [CommonModule, ButtonModule, ProgressBarModule, TooltipModule],
  templateUrl: './file-list.component.html',
  styleUrl: './file-list.component.scss',
})
export class FileListComponent implements OnChanges {
  @Input() disabled = false;
  @Input() files: Observable<FileRepresentation[]> = of([]);
  @Input() existingFileHeader = true;

  @Input() onFileRepresentationChange: ($event: FileRepresentation) => void = () => {
    console.warn('onFileRepresentationChange not passed');
  };
  @Input() openFile: ($event: FileRepresentation) => void = () => {
    console.warn('openFile not passed');
  };
  @Input() onFileDownLoad: ($event: FileRepresentation) => void = () => {
    console.warn('onFileDownLoad not passed');
  };
  @Input() onAllRemoved: () => void = () => {
    console.warn('onAllRemoved not passed');
  };

  // Reactive signal that mirrors the latest observable
  private filesSignal = signal<FileRepresentation[]>([]);
  private subscription: Subscription | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['files']) {
      // Unsubscribe previous observable if it exists
      this.subscription?.unsubscribe();

      // Subscribe to the new observable
      this.subscription = this.files.subscribe(files => {
        this.filesSignal.set(files);
      });
    }
  }

  // Expose the signal to the template
  get fileList() {
    return this.filesSignal();
  }
}
